"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Tree = _interopRequireDefault(require("./Tree"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _Metrics = _interopRequireDefault(require("./Metrics"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Picker = /*#__PURE__*/function (_React$Component) {
  _inherits(Picker, _React$Component);
  var _super = _createSuper(Picker);
  function Picker(props) {
    var _this;
    _classCallCheck(this, Picker);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "selectDataConnector", function (obj) {
      if (!(0, _isEqual2["default"])(_this.state.selectedDataConnector, obj)) {
        _this.setState({
          selectedDataConnector: obj
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDelete", function () {
      _this.props.field.onChange(null);
      _this.props.afterChange();
    });
    _defineProperty(_assertThisInitialized(_this), "handlePicking", function () {
      _this.props.field.onChange(_objectSpread({
        instance: 'dataConnector'
      }, _this.state.selectedDataConnector));
      _this.props.afterChange();
      if (_this.refs.modal) {
        _this.refs.modal.close();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getFilter", function () {
      var type = _this.props.type;
      if (!(0, _isArray2["default"])(type)) {
        type = [type];
      }
      if (type.length === 0) {
        return null;
      }
      return function (node, parent) {
        if (!node.disabled && !node.isAdult && !type.includes(node.type)) {
          return false;
        }
        return (0, _omit2["default"])(node, ['children']);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getNameWithTypes", function () {
      var _this$props = _this.props,
        type = _this$props.type,
        name = _this$props.name;
      return name + '_' + ((0, _isArray2["default"])(type) ? type.join('_') : type);
    });
    _this.state = {
      selectedDataConnector: props.field.value,
      currentTabName: props.field.value && props.field.value.category === 'metrics' ? 'metrics' : 'flow'
    };
    return _this;
  }
  _createClass(Picker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        field = _this$props2.field,
        label = _this$props2.label,
        comment = _this$props2.comment,
        noModal = _this$props2.noModal,
        topRender = _this$props2.topRender;
      var tabs = [{
        name: 'flow',
        label: 'Survey',
        component: /*#__PURE__*/_react["default"].createElement(_Tree["default"], {
          name: this.getNameWithTypes(),
          selectedDataConnector: this.state.selectedDataConnector,
          onSelect: this.selectDataConnector,
          handlePicking: this.handlePicking,
          filter: this.getFilter()
        })
      }, {
        name: 'metrics',
        label: 'Metrics',
        component: /*#__PURE__*/_react["default"].createElement(_Metrics["default"], {
          selectedDataConnector: this.state.selectedDataConnector,
          onSelect: this.selectDataConnector,
          handlePicking: this.handlePicking,
          filter: this.getFilter()
        })
      }];
      var currentTab = tabs.find(function (tab) {
        return tab.name === _this2.state.currentTabName;
      });
      var modalBody = /*#__PURE__*/_react["default"].createElement("div", null, topRender, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "nav nav-tabs",
        style: {
          marginBottom: '1em'
        }
      }, tabs.map(function (tab) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: tab.name,
          className: tab.name === _this2.state.currentTabName ? 'active' : ''
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          onClick: function onClick(e) {
            e.preventDefault();
            _this2.setState({
              currentTabName: tab.name
            });
          }
        }, tab.label));
      })), currentTab.component);
      if (noModal) {
        return modalBody;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: field,
        label: label,
        comment: comment
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '-2px'
        }
      }, field.value ? field.value.title || 'picked' : 'none', /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        ref: "modal",
        title: "Pick data connector",
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: _style["default"].button + ' btn btn-xs btn-default',
          title: "Link data connector"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "glyphicon glyphicon-link"
        })),
        size: "large",
        afterClose: function afterClose() {
          // reset state value
          _this2.setState({
            selectedDataConnector: _this2.props.field.value
          });
        }
      }, modalBody), field.value && /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-default",
        title: "Delete data connector",
        style: {
          marginLeft: '.2em'
        },
        onClick: this.onDelete
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-remove text-danger"
      }))));
    }
  }]);
  return Picker;
}(_react["default"].Component);
exports["default"] = Picker;
_defineProperty(Picker, "propTypes", {
  name: _propTypes["default"].string,
  field: _propTypes["default"].object.isRequired,
  label: _propTypes["default"].node,
  comment: _propTypes["default"].node,
  type: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]).isRequired,
  afterChange: _propTypes["default"].func,
  noModal: _propTypes["default"].bool,
  topRender: _propTypes["default"].node
});
_defineProperty(Picker, "defaultProps", {
  name: 'tree',
  label: 'Data connector',
  afterChange: function afterChange() {},
  noModal: false
});